import React from 'react';
import classNames from 'classnames';

const FooterNav = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'footer-nav',
    className
  );

  return (
    <nav
      {...props}
      className={classes}
    >
      <ul className="list-reset">
        <li>
          <a href="https://github.com/Harshvardhan1609/BitRebelsJava2022JIET" target={"_blank"} rel="noopener noreferrer">Github</a>
        </li>
        <li>
          <a href="https://drive.google.com/file/d/1u5cEdXpMsVtQOhlH5LiO1lzQ3rdQoXk3/view?usp=sharing" target={"_blank"} rel="noopener noreferrer">Syllabus</a>
        </li>
        <li>
          <a href="https://www.instagram.com/bitrebels_com/" target={"_blank"} rel="noopener noreferrer">Community</a>
        </li>
      </ul>
    </nav>
  );
}

export default FooterNav;